import React from 'react';
import { Button, ButtonHierarchies } from '@clockout-dev/design-elements';
import { PlusCircleOutlined } from '@ant-design/icons';
import BalanceRuleRow from '../BalanceRuleRow';
import EmptyState from '../../../../../common/emptyState/EmptyState';
import styles from '../../styles/availableBalanceForm.module.scss';

function OverdraftPanel({ rules = [], options = [], onAdd, onRemove, onUpdate }) {
    const hasOptions = options.length > 0;
    const showEmptyState = hasOptions && rules.length === 0;

    return (
        <div className={styles.panel}>
            {rules.map((rule) => (
                <BalanceRuleRow
                    key={rule.id}
                    rule={rule}
                    conditionType="count"
                    options={options}
                    onUpdate={onUpdate}
                    onRemove={onRemove}
                    disabled={!hasOptions}
                    showTimeframe
                />
            ))}
            {!hasOptions && (
                <p className={styles.disabledHelper}>
                    No additional settings are required based on your segmentation.
                </p>
            )}
            {showEmptyState && (
                <EmptyState
                    title="No overdraft rules yet"
                    description="Add a row to scale the available balance by recent overdrafts."
                />
            )}
            <Button
                type="button"
                hierarchy={ButtonHierarchies.LINK_COLOR}
                icon={<PlusCircleOutlined />}
                className={styles.addRowButton}
                onClick={onAdd}
                disabled={!hasOptions}
            >
                Add a user segment
            </Button>
        </div>
    );
}

export default OverdraftPanel;
